import React from 'react';
import './IOSInstallModal.css';

interface IOSInstallModalProps {
  isOpen: boolean;
  onClose: () => void;
  language: 'de' | 'en';
}

export const IOSInstallModal: React.FC<IOSInstallModalProps> = ({ isOpen, onClose, language }) => {
  if (!isOpen) return null;

  const translations = {
    de: {
      title: 'App installieren',
      subtitle: 'So installierst Du die App auf Deinem iPhone oder iPad:',
      step1: 'Tippe auf das Teilen-Symbol',
      step2: 'Scrolle nach unten und tippe auf "Zum Home-Bildschirm"',
      step3: 'Tippe auf "Hinzufügen"',
      note: 'Hinweis: Die Installation funktioniert nur in Safari, nicht in anderen Browsern.',
      close: 'Schließen'
    },
    en: {
      title: 'Install App',
      subtitle: 'How to install the app on your iPhone or iPad:',
      step1: 'Tap the Share button',
      step2: 'Scroll down and tap "Add to Home Screen"',
      step3: 'Tap "Add"',
      note: 'Note: Installation only works in Safari, not in other browsers.',
      close: 'Close'
    }
  };

  const t = translations[language];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content ios-install-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{t.title}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="modal-body">
          <p className="install-subtitle">{t.subtitle}</p>
          
          <div className="install-steps">
            <div className="install-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <div className="step-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
                    <polyline points="16 6 12 2 8 6"></polyline>
                    <line x1="12" y1="2" x2="12" y2="15"></line>
                  </svg>
                </div>
                <div className="step-text">{t.step1}</div>
              </div>
            </div>
            
            <div className="install-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <div className="step-icon">➕</div>
                <div className="step-text">{t.step2}</div>
              </div>
            </div>
            
            <div className="install-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <div className="step-icon">✓</div>
                <div className="step-text">{t.step3}</div>
              </div>
            </div>
          </div>
          
          <div className="install-note">
            <p>{t.note}</p>
          </div>
        </div>
        
        <div className="modal-footer center">
          <button className="button button-primary" onClick={onClose}>
            {t.close}
          </button>
        </div>
      </div>
    </div>
  );
};